
export default {
    name: 'LeeDialog',
    inheritAttrs: false,
    data() {
        return {
            isshow: false
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.isshow = value
            }
        }
    },
    computed: {


    },
    methods: {
        cancel() {
            this.isshow = false
            this.$emit('input', false)
            this.$emit('cancel',{flag:false})
        },
        certain() {
            this.isshow = false
            this.$emit('input', false)
            this.$emit('certain',{flag:true})
        }

    },
    props: {
        value: {
            type: Boolean,
            default: false //默认default
        },
        title: {
            type: String,
            default: '' //默认default
        },
        effect: {
            type: String,
            default: 'fade' //默认default
        }

    }
};
